// filename: src/components/VueAudio.vue
<template>
  <!-- <div
    class="learning-process-wrapper"
    :style="{ top: `${top}px`, left: `${left}px` }"
  >
    <h3 class="title">学习目标</h3>
    <p class="total-score">{{ totalLoNum }}</p>
    <div class="process">
      <div class="active" :style="{height: `${parseInt(currentPercent)}%`}">
        <div class="animal"></div>
        <div class="current-process">
          <h4>已学习</h4>
          <p>{{ parseInt(knowledgeInfo.studyLoNum) }}</p>
        </div>
      </div>
    </div>
  </div> -->

  <div 
  class="learning-process-wrapper"
  :style="{ top: `${top}px`, left: `${left}px` }">
    <h3>已学会知识点</h3>
    <div class="process-content">
      <div class="active">
        <div class="current-process">
          <sl-steps :active="0" direction="vertical">
            <sl-step :space="48" v-for="item in dataList" 
            :key="item.crystalGear"
            :class="{ 'is-sucess': currentPercent >= item.crystalValue}">
              <div class="process-left tips">{{ item.crystalValue + '%' }}</div>
              <div class="crystal crystal-num">
                <img src="./images/diamond.png" width="20" alt="">
                <span class="num-text">x{{ item.crystalNum }}</span>
              </div>
            </sl-step>
            <div class="line-hightlight" :style="{ height: currentPercent + '%' }"></div>
          </sl-steps>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import slStep from "@/components/Step/slStep"
import slSteps from "@/components/Step/slSteps"
import crystalData from '../dispose'
import { getUserLocalData } from "@/utils/auth";
export default {
  name: "LearningProcess",
  data() {
    return {
      curValue: 25,
      dataList: []
    };
  },
  components: {
    slStep, slSteps
  },
  props: {
    top: {
      type: Number,
      default: 150
    },
    left: {
      type: Number,
      default: 13
    },
    knowledgeInfo: {
      type: Object
    },
    totalScore: {
      type: Number,
      default: 0
    },
    currentScore: {
      type: Number,
      default: 0
    },
  },
  computed: {
    currentPercent() {
      let { unlockLoNum,studyLoNum } = this.knowledgeInfo
      let per
      if (parseInt(studyLoNum) > 0) {
        let { allPoint } = getUserLocalData()
        let perPoint = allPoint ? allPoint : unlockLoNum
        per = Math.round((parseInt(studyLoNum)/parseInt(perPoint)).toFixed(2) * 100)
        return per
      } else {
        return 0
      }
    },
    totalLoNum() {
      let unlockLoNum = this.knowledgeInfo.unlockLoNum?parseInt(this.knowledgeInfo.unlockLoNum):0
      return unlockLoNum
    }
  },
  created(){
    this.dataList = crystalData()
  },
  mounted(){
    
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.learning-process-wrapper {
  width: 126px;
  // height: 286px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  text-align: center;
  background: url("./images/process-bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: absolute;
  z-index: 99;
  h3 {
    color: rgba(0, 255, 249, 1);
    font-weight: 600;
    line-height: 20px;
    margin-top: 12px;
  }
  .total-score {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,255,249,1);
    line-height: 28px;
  }
  .process-content {
    margin-top: 40px;
    margin-bottom: 20px;
    .process-left {
      position: absolute;
      &.tips {
        width: 40px;
        height: 17px;
        background:rgba(0,178,255,1);
        border-radius: 4px;
        top: -8px;
        left: 12px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:17px;
        text-align: center;
        &:after {
          content: '';
          width:0;
          height:0;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 5px solid rgba(0,178,255,1);
          position: absolute;
          right: -4px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .crystal {
      // width: 90px;
      position: absolute;
      top: -10px;
      right: 0px;
      display: flex;
      min-width: 60px;
      .num-text {
        font-size:14px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:#fff;
        line-height:20px;
      }
    }
    .line-hightlight {
      position: absolute;
      background:linear-gradient(180deg,rgba(0,255,248,1) 0%,rgba(0,178,255,1) 100%);
      border-radius:2px;
      width: 4px;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      transition: height .8s;
    }
  }
  .process {
    width: 18px;
    height: 190px;
    background: url("./images/process.png") no-repeat;
    background-size: contain;
    box-sizing: border-box;
    margin: 4px auto 16px;
    position: relative;
    .active {
      width: 100%;
      background: url("./images/process-active.png") no-repeat;
      background-size: cover;
      background-position: center bottom;
      position: absolute;
      bottom: 0;
      left: 0;
      .animal {
        width: 25px;
        height: 28px;
        background: url("./images/animal.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: -16px;
        right: 27px;
      }
      .current-process {
        font-family:Helvetica;
        width: 52px;
        height: 40px;
        text-align: center;
        background: url("./images/info-dialog.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: -20px;
        left: 22px;
        padding-left: 4px;
        h4 {
          font-size:10px;
          color:rgba(0,255,249,1);
          line-height:12px;
          margin-top: 8px;
        }
        p {
          font-size:14px;
          color:rgba(0,255,249,1);
          line-height:17px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
   
  .current-process {
    .sl-steps {
      .sl-step {
        &.is-sucess {
          .sl-step_head {
            position: relative;
            .sl-step_icon {
              width:6px;
              height:6px;
              background:rgba(0,255,249,1);
              border:2px solid rgba(0,255,249,1);
              position: absolute;
              z-index: 50;
            }
          }
          .crystal {
            .num-text {
              color: #00fff9;
            }
          }
        }
      }
    }
    border-color: red;
    
  }

</style>



// WEBPACK FOOTER //
// src/components/LearningProcess/index.vue